<template>
	<div class="content">
		<div class="content-Statistical">
			<header>统计数据查询</header>
			<van-cell title="选择日期区间" :value="date" @click="show = true" />
			<van-calendar v-model="show" type="range" :min-date="minDate" @confirm="onConfirm" allow-same-day />
			<div id="myChart" ref="myChart" style="width: 100%;height:300px;"></div>
		</div>
		<div class="data-comparison">
			<!-- <van-cell title="选择日期区间" :value="comparionDate" @click="showComparionDate = true" />
			<van-calendar v-model="showComparionDate" type="range" :min-date="minDate" @confirm="onConfirmComparison"
				allow-same-day /> -->
			<div class="comparison-tree">
				<div class="comparison-tree-column" v-for="(value, key) in comparisonData" :key="key">
					<div class="comparison-tree-column-header">{{ key }}</div>
					<div class="comparison-tree-cell-data" v-for="cell in value" :key="cell.id">
						{{ `${cell.time}(` }}<span style="font-weight: bold;">{{cell.num}}</span>)
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getTotalListByDate,
	getList
} from '../util/api'
export default {
	name: 'StatisticsDataCom',
	data() {
		return {
			date: '',
			comparionDate: '',
			show: false,
			showComparionDate: false,
			minDate: new Date('2024-06-24'),
			comparisonData: {}
		}
	},
	methods: {
		formatDate(date) {
			return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
		},
		onConfirm(date) {
			const [start, end] = date;
			this.show = false;
			const startDate = this.formatDate(start);
			const endDate = this.formatDate(end);
			this.date = `${startDate} 到 ${endDate}`;
			if (startDate && endDate) {
				this.getTotalListByDate({ startDate, endDate })
				this.getList({ startDate, endDate })
			}
		},
		onConfirmComparison(comparionDate) {
			const [start, end] = comparionDate;
			this.showComparionDate = false;
			const startDate = this.formatDate(start);
			const endDate = this.formatDate(end);
			this.comparionDate = `${startDate} 到 ${endDate}`;
			this.getList({ startDate, endDate })
		},
		getList(dateRange) {
			getList({
				...dateRange,
				isAsc: true
			}).then((res) => {
				if (res?.data?.length > 0){
					this.$set(this, 'comparisonData', this.groupByDate(res.data));
				}
					
			})
		},
		getTotalListByDate(dateRange) {
			getTotalListByDate(dateRange).then((res) => {
				const data = res?.data || [];
				const xData = []
				const yData = []
				if (data.length > 0) {
					data.forEach(ele => {
						xData.push(ele.date.substring(5, 10))
						yData.push(ele.total)
					});
				}
				const option = {
					xAxis: {
						type: 'category',
						data: xData
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							data: yData,
							type: 'line',
							smooth: true,
							label: {
								show: true // 显示数值
							},
						}
					]
				}
				this.setChart(option);
			})
		},
		setChart(option) {
			// 在步骤2的方法1中 通过 this.$echarts.init方法初始化echarts实例并使用 setOption 方法注册图表配置项和数据
			let myChart = this.$echarts.init(document.getElementById("myChart"));
			myChart.setOption(option);
			window.addEventListener("resize", function () {
				myChart.resize();
			});
		},
		groupByDate(list) {
			(list || []).sort((a,b) => new Date(a.time) - new Date(b.time))
			return list.reduce((acc, item) => {
				const date = new Date(item.time)
				const dateStr = `${date.getMonth() + 1}-${date.getDate()}`;
				if (!acc[dateStr]) {
					acc[dateStr] = [];
				}
				acc[dateStr].push({
					...item,
					time: `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
				});
				return acc;
			}, {});
		}
	},
	mounted() {
		// this.getChart();
		// let myChart = this.$echarts.init(document.getElementById("myChart"));
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	/* Q版：柔和底色 + 卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;

	padding: 14px 14px 18px;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 140px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 90px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content-Statistical,
.data-comparison {
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	padding: 12px;
	box-sizing: border-box;
}

header {
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	letter-spacing: 0.2px;
}

#myChart {
	margin-top: -32px;
}
.data-comparison{
	flex: 1;
    overflow: auto;
}
.comparison-tree{
	display: flex;
	overflow-x: auto;
	height: 100%;
}
.comparison-tree-column{
	flex: 1;
	padding: 0 6px;
}
.comparison-tree-column-header{
	font-size: 16px;
	font-weight: bold;
	height: 32px;
	line-height: 32px;
}
.comparison-tree-cell-data{
	line-height: 48px;
}
</style>
